import { render, staticRenderFns } from "./ScarDetail.vue?vue&type=template&id=bb63dffc&scoped=true"
import script from "./ScarDetail.vue?vue&type=script&lang=js"
export * from "./ScarDetail.vue?vue&type=script&lang=js"
import style0 from "./ScarDetail.vue?vue&type=style&index=0&id=bb63dffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb63dffc",
  null
  
)

export default component.exports